import React, { useContext, useState, useEffect } from "react";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import { toast } from "react-toastify";
import { Content, Header, Footer } from "../styles";
import NumberInput from "~/shared/NumberInput";
import { Row, Col } from "react-bootstrap";
import TextareaInput from "~/shared/TextareaInput";

type EssayProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
};

const extraFields = {
    number_of_photos: {
        name: "Numero aproximado de fotos",
        value: "",
        type: "numero",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Essay = ({ nextStep, goToStep }: EssayProps) => {
    const { values, confirmationStep, handleChange, updateValuesInLocalStorage, setValues } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [numberOfPhotos, setNumberOfPhotos] = useState<string>(values?.extra?.number_of_photos?.value || "");

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const briefing = `Informações\nNúmero aproximado de fotos: ${
        values?.extra?.number_of_photos?.value || numberOfPhotos
    }`;

    const validateAndNextStep = () => {
        if (!values.subcategory) return toast.error("Selectio um tipo de ensaio");

        if (!numberOfPhotos.length) {
            return toast.error("Número aproximado de fotos e obrigatório!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Content>
                <div className="title">
                    <p>Informações</p>
                    <div className="bar" />
                    <Row className="input-content">
                        <Col>
                            <NumberInput
                                name="number_of_photos"
                                label="Número aproximado de fotos"
                                value={numberOfPhotos}
                                onChange={(name: string, value: string) => {
                                    handleExtraFieldChange(name, value);
                                    setNumberOfPhotos(value);
                                }}
                            />
                        </Col>
                    </Row>
                </div>
            </Content>
            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Essay;
